"use strict";

export default class LegalController {
  /*@ngInject*/
  constructor(LanguageService) {
    this.ls = LanguageService;
    this.message = "test jilfkjgilj";
  }
}



// WEBPACK FOOTER //
// ./client/app/account/legal/legal.controller.js